var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.asset)?_c('div',[_c('a',{attrs:{"href":_vm.thumbnailUrl,"target":"_blank"}},[_c('img',{attrs:{"src":_vm.asset.thumbnail,"srcset":_vm.srcset,"width":_vm.width,"height":"auto"},on:{"error":_vm.imgUrlDefault}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }